import React, {useState} from "react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";
import {useMobileDetect} from "../../../utils/Hooks";
import ActiveBlackFilterButton from "../../_common/component/ActiveBlackFilterButton";
import {COURSE_FILTER_ALL, COURSE_FILTER_EXPIRED, COURSE_FILTER_ON_GOING} from "../../../constant/options";
import {BROADCAST_ON_FILTER_BUTTON_CHANGE, useApplicationContext} from "../../../context/ApplicationContextProvider";

const FilterButtons = (props) => {
    const {is_mobile} = useMobileDetect();
    const {broadcast} = useApplicationContext();

    // state
    const [filter_num, setFilterNum] = useState(props.filter_flag);

    // css style
    const {view} = useComponentStyle(is_mobile);

    const onFilterButtonClick = (filter_flag) => {
        window.scroll(0, 0);

        if (filter_flag === COURSE_FILTER_ALL) {
            setFilterNum(COURSE_FILTER_ALL);
        } else if (filter_flag === COURSE_FILTER_ON_GOING) {
            setFilterNum(COURSE_FILTER_ON_GOING);
        } else if (filter_flag === COURSE_FILTER_EXPIRED) {
            setFilterNum(COURSE_FILTER_EXPIRED);
        }

        broadcast.send(BROADCAST_ON_FILTER_BUTTON_CHANGE, filter_flag);
    };

    return (
        <view.FilterButtonSection>
            <div className="filter-button-wrapper">
                <ActiveBlackFilterButton
                    is_not_cancel={true}
                    content={`전체 ${props.course_list.length || ""}`}
                    is_active={filter_num === COURSE_FILTER_ALL}
                    on_click={() => {
                        onFilterButtonClick(COURSE_FILTER_ALL);
                    }}
                />
                <ActiveBlackFilterButton
                    content={`수강중`}
                    is_active={filter_num === COURSE_FILTER_ON_GOING}
                    on_click={() => onFilterButtonClick(COURSE_FILTER_ON_GOING)}
                />
                <ActiveBlackFilterButton
                    content={`수강만료`}
                    is_active={filter_num === COURSE_FILTER_EXPIRED}
                    on_click={() => onFilterButtonClick(COURSE_FILTER_EXPIRED)}
                />
            </div>
        </view.FilterButtonSection>
    );
};

export default FilterButtons;

export const useComponentStyle = (is_mobile) => {
    const theme = useTheme();
    return {
        view: {
            FilterButtonSection: styled.div({
                position: is_mobile && "fixed",
                top: is_mobile && "8.2em",
                zIndex: "6000",
                backgroundColor: theme.colors.w,
                borderBottom: is_mobile && `1px solid ${theme.colors.lg1}`,
                height: "5em",
                width: "100%",
                "@media(max-width: 320px)": {
                    top: "7.2em",
                    height: "4.2em",
                },
                "& > .filter-button-wrapper": {
                    width: is_mobile ? "92%" : "100%",
                    height: "100%",
                    margin: "auto",
                    display: "flex",
                    alignItems: "center",
                    div: {
                        marginRight: ".2em",
                        minWidth: "3.5em",
                    },
                },
            }),
        },
    };
};
